import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { fetchRoleById } from "../services/users-service";
import Alert from "react-bootstrap/Alert";
import MessageQueuesPermissions from "./MessageQueuesPermissions";
import DashboardPermissions from "./DashboardPermissions";
import DataTablesPermissions from "./DataTablesPermissions";
import NavBarPermissions from "./NavBarPermissions";
import RulesPermissions from "./RulesPermissions";
import ReportingPermissions from "./ReportingPermissions";
import SettingsPermissions from "./SettingsPermissions";

const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    marginRight: theme.spacing(1),
    color: "#0365C0",
    fontWeight: 400,
    fontSize: "16px",
    backgroundColor: "#FFFFFF",
    fontFamily: ["Roboto"].join(","),
    "&:hover": {
      color: "#0839AD",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#000000",
      fontWeight: theme.typography.fontWeightBold,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#000000",
    },
  })
);

const Permissions = () => {
  const location = useLocation();
  const [formatTab, setFormatTab] = useState("1");
  const [isError, setIsError] = useState(false);
  const [roleData, setRoleData] = useState({});

  const handleFormatTabChange = (event, newValue) => {
    setFormatTab(newValue);
  };

  const getRoleById = async () => {
    let roleId = location?.state?.row?.roleId;
    let response = await fetchRoleById(roleId);

    if (response.ok) {
      let data = await response.json();
      setRoleData(data);
    } else {
      setIsError(true);
    }
  };

  useEffect(() => {
    if (location?.state?.row?.roleId != null) {
      getRoleById();
    }
  }, []);

  const renderBannerMessage = () => {
    if (isError) {
      return "Something went wrong, please try again";
    }
  };

  return (
    <>
      <Container fluid className="errorMessageContainer">
        <Row>
          <Col xl={8}>
            <Row className="tableTitle generalFont">
              {location?.state?.row?.roleName}
            </Row>
            <Row className="tableSubtitle generalFont">
              View Permissions for the Role
            </Row>
          </Col>
        </Row>
        <Row style={{ width: "97%" }}>
          {isError && (
            <Alert
              key={"success"}
              variant={isError ? "danger" : "success"}
              onClose={() => {
                setIsError(false);
              }}
              dismissible
            >
              {renderBannerMessage()}
            </Alert>
          )}
        </Row>

        <Row
          className="summaryContainer"
          style={{ display: "flex", paddingBottom: "15px" }}
        >
          <Row style={{ marginTop: "20px" }}>
            <Col sm={2} className="permSummaryColStyleLabel">
              <span className="textSmallFontBig generalFont">Description:</span>
            </Col>
            <Col sm={5} className="permSummaryColStyle">
              <span className="textSmallFontSm generalFont">
                {roleData?.roleDescription != null
                  ? roleData.roleDescription
                  : "-"}
              </span>
            </Col>
            <Col sm={2} className="permSummaryColStyleLabel">
              <span className="textSmallFontBig generalFont">Status:</span>
            </Col>
            <Col sm={3} className="permSummaryColStyle">
              <span className="textSmallFontSm generalFont">
                <div
                  className={`${
                    roleData?.isActive ? "activeColStyle" : "inactiveColStyle"
                  }`}
                  style={{ width: "120px" }}
                >
                  {roleData?.isActive ? "Active" : "Inactive"}
                </div>
              </span>
            </Col>
          </Row>
        </Row>
        <Row>
          <Col xl={8}>
            <Row className="tableTitle generalFont">Permission Sets</Row>
          </Col>
        </Row>

        <Row style={{ marginRight: "54px", marginTop: "40px" }}>
          <Box
            sx={{
              width: "100%",
              typography: "body1",
              paddingLeft: "0px",
              paddingRight: "0px",
            }}
          >
            <TabContext sx={{ height: "38px" }} value={formatTab}>
              <TabList
                onChange={handleFormatTabChange}
                aria-label="Format Tabs"
              >
                <AntTab label="Navigation Bar" value="1" />
                <AntTab label="Dashboard" value="2" />
                <AntTab label="Message Queues" value="3" />
                <AntTab label="Data Tables" value="4" />
                <AntTab label="Rules" value="5" />
                <AntTab label="Reporting" value="6" />
                <AntTab label="Settings" value="7" />
              </TabList>
              <TabPanel className="noPaddMarginTop40" value="1">
                <NavBarPermissions role = {roleData} />
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="2">
                <DashboardPermissions role = {roleData} />
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="3">
                <MessageQueuesPermissions role = {roleData} />
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="4">
                <DataTablesPermissions role = {roleData} />
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="5">
                <RulesPermissions role = {roleData} />
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="6">
                <ReportingPermissions />
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="7">
                <SettingsPermissions role = {roleData} />
              </TabPanel>
            </TabContext>
          </Box>
        </Row>
      </Container>
    </>
  );
};

export default Permissions;
